import {Component} from "@angular/core";
import {FormFieldDto} from "../../../core/interfaces/core.types";
import {RegistrationApiService} from "../../../rg/api/registration-api.service";
import {SignUpService} from "../../../rg/service/sign-up.service";
import {CoreApiService} from "../../../core/service/core-api.service";
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {FormRegistrationFieldsDto} from "../../../rg/types/registration.types";
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {UserChannelsApiService} from "../../../cross/user-channels/api/user-channels-api.service";
import {ChannelDto, ChannelOverviewDto} from "../../../cross/user-channels/types/user-channels.types";
import {MessageService} from "primeng/api";
import {AppMessageService} from "../../../core/service/app-message.service";
import {MessageHelper} from "../../../core/helper/message-helper";
import {SettingsService} from "../../service/settings.service";


@Component({
  selector: 'us-notifications',
  templateUrl: './us-notifications.component.html',
  styleUrl: './us-notifications.component.scss'
})
export class UsNotificationsComponent extends CoreComponent {

  formGroup: FormGroup | undefined;
  notification: ChannelOverviewDto | undefined;

  constructor(
    protected settingService: SettingsService,
    protected coreApiService: CoreApiService,
    protected messageService: AppMessageService,
    protected userChannelsApiService: UserChannelsApiService) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.settingService.setHeader('Benachrichtigungen', 'Hier kannst du auswählen, wie wir dich kontaktieren dürfen');
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.getNotifications();
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }

  getNotifications() {
    this.userChannelsApiService.getChannels().subscribe(res => {
      this.notification = res;
      this.createFormGroup();
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
    })
  }

  createFormGroup() {
    if (this.notification && this.notification.channels) {
      this.formGroup = this.buildFormGroup(this.notification.channels as ChannelDto[]);
    }
  }

  buildFormGroup(channels: any[]): FormGroup {
    const channelsArray = new FormArray<FormGroup>([]);

    for (const channel of channels) {
      const channelGroup = new FormGroup({});
      for (const key in channel) {
        if (channel.hasOwnProperty(key)) {
          const control = new FormControl(channel[key]);
          channelGroup.addControl(key, control);
        }
      }
      channelsArray.push(channelGroup);
    }

    return new FormGroup({
      channels: channelsArray
    });
  }

  get channelsFormArray(): AbstractControl[] {
    return (this.formGroup?.get('channels') as FormArray).controls;
  }

  updateNotifications() {
    this.busy = true;
    const channels = this.formGroup?.get('channels')?.value;
    const newDto: ChannelDto[] = channels.map((item: any) => ({
      channelTypeId: item.channelTypeId,
      confirmed: item.confirmed
    }));

    const objToPush: ChannelOverviewDto = {
      messageOnUpdate: this.notification?.messageOnUpdate as string,
      channels: newDto
    };

    this.userChannelsApiService.saveChannels(objToPush).subscribe(res => {
      MessageHelper.showSuccessMessage(res.messageOnUpdate, this.messageService);
      this.busy = false;
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
      this.busy = false;
    })
  }

}
